export default __webpack_public_path__ + "static/media/no-trackers.4f0436af.png";